
export class SearchAvtalByAnvandareRequestDTO   {

    anvandareId: number;
    kontraktstatus?: string;
    affarsform?: string;
    vacsStatus?: number;

    constructor() {
        this.anvandareId = undefined;
        this.kontraktstatus = undefined;
        this.affarsform = undefined;
        this.vacsStatus = undefined;
    }
}
